export const checkPermissions = {
  canCreateEmployee: (userRole) => {
    const lowerRole = userRole.toLowerCase();
  return lowerRole !== "bde" && lowerRole !== "trainer" && lowerRole !== "placement officer";
  },
    
    canCreateCourse: (userRole) => {
      return userRole === "Super-Admin" || userRole === "super-admin";
    },
    
    canViewCourseDetails: (userRole) => {
      return userRole === "Super-Admin" || userRole === "super-admin";
    },
    canViewEmployees: (userRole) => {
      const normalizedRole = userRole.toLowerCase();
      return normalizedRole === "super-admin" || normalizedRole === "branch-head";
    }
  };
  
  export const getRoleOptions = (userRole) => {
    if (userRole === "Branch-head" || userRole === "branch-head") {
      return [
        { value: "BDE", label: "BDE" },
        { value: "Trainer", label: "Trainer" },
        { value: "Placement officer", label: "Placement Officer" }
      ];
    } else {
      return [
        { value: "BDE", label: "BDE" },
        { value: "Trainer", label: "Trainer" },
        { value: "Placement officer", label: "Placement Officer" },
        { value: "Branch-head", label: "Branch Head" },
        { value: "Super-Admin", label: "Super Admin" }
      ];
    }
  };